module.exports = {
  base_url: process.env.REACT_APP_BASE_URL,
  site_url: process.env.REACT_APP_SITE_URL,
};
